import { AspectRatio, Box, Flex, SimpleGrid, Stack } from "@chakra-ui/react";
import Icon from "@modules/Icon";
import useMediaModal from "@modules/Resource/hooks/useMediaModal";
import React from "react";
import { Else, If, Then } from "react-if";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { MediaContent } from "@types/common";
import { BrandHeadingHero, MediaCoverHero } from "../style";
import ActionButton from "./ActionButton";
import FluidImage from "./FluidImage";
import MediaModal from "./MediaModal";

interface Props {
  data: MediaContent;
  coverBorder?: "xs" | "md" | "lg" | "xl" | "2xl" | "none";
}

const MediaCustomCover: React.FC<Props> = ({ data, coverBorder = "none" }) => {
  if (!data) {
    return null;
  }

  const coverImage = data.cover?.url;
  const isVideo = data.media_type === "video";
  const hasMedia = coverImage || data.media_url;

  const { isOpen, handleOpenModal, handleCloseModal } = useMediaModal();

  return (
    <MediaCoverHero>
      <SimpleGrid
        columns={[1, 1, 2]}
        spacing={{ base: 5, lg: 40 }}
        alignItems={"center"}
        minH={{ base: "auto", md: "400px" }}
      >
        <Box pl={{ base: 4, md: 0 }} pr={{ base: 4, md: 0 }}>
          <BrandHeadingHero>
            <ReactMarkdown children={data.content.data.content} />
            <ActionButton actions={data.action} />
          </BrandHeadingHero>
        </Box>

        <Flex
          direction={["column", "column", "row"]}
          alignItems="center"
          justifyContent={["center", "center", "normal"]}
          pr={{ base: 0 }}
          minH={{ base: "250px", md: "350px" }}
          opacity={hasMedia ? 1 : 0}
          visibility={hasMedia ? "visible" : "hidden"}
        >
          <If condition={hasMedia}>
            <Then>
              <AspectRatio ratio={16 / 9} w="100%" maxW="600px">
                <Box>
                  <If condition={isVideo && data?.media_url}>
                    <Then>
                      <Stack
                        position="relative"
                        onClick={() =>
                          handleOpenModal("video", data?.media_url)
                        }
                        style={{ cursor: "pointer" }}
                        className="custom-video-cover"
                        w="100%"
                        h="100%"
                      >
                        <FluidImage
                          imageItem={data.cover}
                          borderRadius={coverBorder}
                          width="100%"
                          height="100%"
                          style={{ objectFit: "cover" }}
                        >
                          <Icon
                            className="custom-video-play-icon"
                            name="playVideo"
                          />
                        </FluidImage>
                      </Stack>
                    </Then>
                    <Else>
                      <FluidImage
                        imageItem={data.cover}
                        borderRadius={coverBorder}
                        width="100%"
                        height="100%"
                        style={{ objectFit: "cover" }}
                        loading="lazy"
                        placeholder="blur"
                      />
                    </Else>
                  </If>
                </Box>
              </AspectRatio>
            </Then>
          </If>
        </Flex>
      </SimpleGrid>

      <If condition={data.media_url}>
        <Then>
          <MediaModal
            type={"video"}
            url={data.media_url}
            isOpen={isOpen}
            handleCloseModal={handleCloseModal}
          />
        </Then>
      </If>
    </MediaCoverHero>
  );
};

export default MediaCustomCover;
